import * as zod from 'zod'
import { CompanyTypeValue } from 'api/companies/companyType'

const companyType: zod.ZodType<CompanyTypeValue> = zod.enum([
  '1099',
  'w2',
  'w2_everify',
])

export const createCompanyFlowSchema = zod.object({
  companyName: zod
    .string()
    .min(1, { message: 'Company name is required' })
    .max(60, { message: 'Company name must not exceed 60 characters' }),

  type: companyType,
})

export type CreateCompanyFlowSchema = zod.infer<typeof createCompanyFlowSchema>
